// Feb-2026 — Initial-Formularzustand für CreateListingPage, ausgelagert aus
// CreateListingPage.jsx im Rahmen der Modularisierung. Reine Daten-Defaults,
// keine Logik. Wird als `useState`-Startwert verwendet.
export const INITIAL_LISTING_FORM = {
    category: "motorcycle",
    title: "",
    brand: "",
    model: "",
    vehicle_type: "Roller/Scooter",     // Phase 3.70 — Default Mai-2026: Roller/Scooter (häufigster Fall)
    price: "",
    year: new Date().getFullYear(),
    // Phase 3.50 — Erstzulassung als YYYY-MM-DD String (HTML date input)
    first_registration_date: "",
    mileage: 0,
    condition: "Gebrauchtfahrzeug",  // Phase 3.51 — neue Default-Option
    emission_class: "",                // Phase 3.51 — Schadstoffklasse
    color: "",
    color_finish: "",                  // Phase 3.52 — matt | glaenzend
    color_base: "Weiß",                // Phase 3.52 — Default Mai-2026: Weiß
    description: "",
    location: "",
    street: "",                        // Phase 3.52 — Straße aus Händlerprofil
    postal_code: "",
    // Phase 3.52 — Erweiterte Fahrzeugdaten
    previous_owners: 1,
    next_inspection_date: "",
    warranty_months: "",
    has_service_book: false,
    accident_free: true,
    // Phase 3.89 — Unfall/Schaden-Erweiterung
    is_accident_vehicle: false,
    has_tipover_damage: false,
    is_roadworthy: true,
    damage_info: "",
    // Phase 3.52 — Sharing-Eingabedaten
    sharing_price_per_day: "",
    sharing_min_days: "",
    sharing_max_days: "",
    sharing_deposit_eur: "",
    sharing_pickup_address: "",
    sharing_available_weekdays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    // Jun-2026 (User-Wunsch) — Sharing-Tarife Woche / Monat / Saison (Saison mit Von/Bis)
    sharing_price_per_week: "",
    sharing_price_per_month: "",
    sharing_price_per_season: "",
    sharing_season_from: "",
    sharing_season_to: "",
    images: [],
    image_labels: [],                  // Phase 3.51 — index-aligned zu ``images``
    video_url: "",                     // Phase 3.51 — optionaler Video-Link/Upload
    sale_type: "fixed",
    starting_price: "",
    reserve_price: "",
    min_increment: 50,
    auction_end: "",
    buy_now_price: "",
    auction_audience: "b2b_only",
    // Jun-2026 (User-Wunsch) — Pfand / Refinanzieren Verkaufsart
    pawn_payout_eur: "",
    pawn_term_months: "",
    pawn_buyback_eur: "",
    pawn_usages: [],
    allow_offers: false,
    min_offer_amount: "",
    auto_counter_amount: "",
    instant_buy_enabled: false,
    missed_call_alerts_enabled: true,
    allow_tradein: true,
    allow_chat: true,
    // Feb-2026 (User-Wunsch 24 May) — Probefahrten pro Inserat
    allow_test_ride: false,
    sharing_enabled: false,  // Phase 3.50 — Sharing/Vermietung pro Inserat
    assigned_seller_id: null,  // Phase 4c++ — Verkäufer-Zuordnung
    fuel: "Benzin",
    power_kw: "",
    power_hp: "",
    displacement: 49,               // Mai-2026 Default: 49 ccm (50er Roller)
    transmission: "Automatik",      // Mai-2026 Default: Automatik (Roller-Standard)
    drive_type: "Riemen",            // Mai-2026 Default: Riemen (Roller-Standard)
    // Phase 3.57 — Erweiterte Motorrad-Felder
    cylinder_count: "1",            // Mai-2026 Default: 1 Zylinder
    umweltplakette: "gruen",       // Phase 3.71 — Default „grün"
    seat_count: "2",                // Phase 3.71 — Sitzanzahl Default 2
    // Phase 3.71 — Sichtbarkeit für Käufergruppen (Mai-2026 Iteration 2: standardmäßig BEIDE angehakt, User-Wunsch 21 May)
    visibility_b2c: true,
    visibility_b2b: true,
    // Phase 3.72 — Lagerbestand (Neufahrzeuge) + B2B-Preis + TÜV neu
    stock_count: "",
    // Feb-2026 (User-Wunsch 27.05.2026) — Lager-Status (Vorlauf / Bestand / Bestell).
    // Optional — wenn gesetzt, wird Mengen-Eingabe (stock_count) sichtbar.
    stock_state: "",
    price_b2b: "",
    tuev_neu: false,
    // Phase 3.73 — Sofortmitnahme / Abholung
    pickup_available: false,
    pickup_with_registration: false,
    pickup_unregistered_transport: false,
    delivery_nationwide: false,
    // Phase 3.73 — MwSt — Default: NICHT angehakt (Differenzbesteuerung)
    vat_included: false,
    vat_export_net_calculation: false,
    vat_export_refund_after_docs: false,
    // Phase 3.78 — Vermittlungsprovision (Euro, max 3-stellig)
    referral_commission_eur: "",
    // Mai-2026 (User-Wunsch 21 May Iteration 8) — E-Antrieb-Zusatzfelder
    electric_range_km: "",
    electric_battery_health_pct: "",
    electric_battery_type: "",            // "fest" | "herausnehmbar" | ""
    electric_battery_certificate: false,
    // Mai-2026 (User-Wunsch 21 May Iteration 8) — Quad-Zusatzfelder
    quad_allwheel_drive: false,
    quad_lof_zulassung: false,
    quad_towbar: false,
    // Mai-2026 (User-Wunsch 21 May Iteration 13) — Sitzhöhe + Tankinhalt
    seat_height_mm: "",
    tank_capacity_l: "",
    // Phase 3.73 — Standort-Extras
    stand_platz: "",
    schluessel_nummer: "",
    leitzahl: "",
    // Jul-2026 (User-Wunsch) — Schlüsseldepot (physischer Ablageort des Schlüssels)
    key_depot: "",
    // Jun-2026 (User-Wunsch) — interner Dispo-Vermerk + Fahrzeugpapierinventur
    dispo_internal_note: "",
    papers_inventory_code: "",
    papers_inventory_last_counted_at: "",
    // Phase 3.74 — Portal-Transaktion (Auktion / Direktkauf)
    vin: "",
    key_count: "",
    // Jun-2026 (User-Wunsch) — Vorführfahrzeug-Nutzung (nur bei zugelassen + Vorführfahrzeug)
    vorfuehr_usage: "",
    vorfuehr_employee_id: "",
    vorfuehr_employee_name: "",
    vorfuehr_workshop_site_code: "",
    vorfuehr_workshop_site_name: "",
    vorfuehr_other_text: "",
    // Phase 4.20 — Erweiterte ZB1/COC-Stammdaten
    hsn: "",
    tsn: "",
    manufacturer: "",
    vehicle_class: "",
    license_plate: "",
    max_speed_kmh: "",
    length_mm: "",
    width_mm: "",
    height_mm: "",
    weight_kg: "",
    max_weight_kg: "",
    bemerkungen: "",
    // Phase 4.20 — Vorbesitzer-Stammdaten (aus ZB1 C.1.x)
    previous_owner_first_name: "",
    previous_owner_last_name_or_company: "",
    previous_owner_street: "",
    previous_owner_house_number: "",
    previous_owner_postal_code: "",
    previous_owner_city: "",
    has_handsender: false,
    has_keyless_transponder: false,
    has_immobilizer_card: false,
    has_coc: false,
    has_zb1: false,
    has_zb2: false,
    document_urls: [],
    // Phase 3.86 — Lagerort der Fahrzeugpapiere
    papers_in_house: false,
    papers_in_house_location: "",
    papers_refinanced: false,
    papers_refinanced_bank: "",
    papers_refinanced_date: "",
    // Phase 3.89 — Versendet an Käufer
    papers_shipped_to_buyer: false,
    papers_shipped_date: "",
    features: [],
    accessories: [],
    warranty_type: "",
    last_service_date: "",     // YYYY-MM
    workshop_inspected: false,
    tuev_until: "",            // YYYY-MM
    last_deregistration_date: "", // Phase 4g.B — YYYY-MM oder YYYY-MM-DD
    service_notes: "",          // Phase 3.82 — Freitext Service & Wartung
    range_km: "",
    charging_time_hours: "",
    battery_certificate: false,
    bike_type: "",
    frame_material: "",
    frame_size: "",
    wheel_size: "",
    gears: "",
    // Phase 3.66 — Werbung & Reichweite
    boost_on_publish: false,
    publish_to_exchanges: [],
    publish_to_social: [],
    // Phase 3.68 — Warenwirtschaft eBay-Markierung
    ebay_sync_enabled: false,
};
